//For converting hexidecimal numbers to Big number and convert to a decimal
import { Tooltip } from 'antd'

import BigNumber from 'bignumber.js'

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export function web3BNToFloatString(
  bn,
  divideBy,
  decimals,
  roundingMode = BigNumber.ROUND_DOWN
) {
  const converted = new BigNumber(bn.toString())
  const divided = converted.div(divideBy)
  return divided.toFixed(decimals, roundingMode)
}

export const saveToLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const getFromLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key))
}

export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key)
}

export const shortNumber = (num) => {
  return <Tooltip title={num}>{Number(num).toFixed(4)}</Tooltip>
}

export const wallets = [
  {
    id: "1",
    modalname: "Metamask",
    image:
      "https://seeklogo.com/images/M/metamask-logo-09EDE53DBD-seeklogo.com.png",
  },
  {
    id: "2",
    modalname: "WalletConnect",
    image:
      "https://api.nuget.org/v3-flatcontainer/walletconnect.core/1.7.1/icon",
  },
  {
    id: "3",
    modalname: "BSC wallet",
    image: "https://exchange.derace.com/assets/images/bsc.png",
  },
]